<template>
    <div class="profile">
        <p-header title="個人資訊"/>
        <div class="info">
            <div class="name">
                {{ user.name }}
            </div>
            <div class="gender">
                {{ user.gender | gender }}
            </div>
        </div>
        <div class="menu">
            <div class="item">
                <div class="title">
                    <img src="@/assets/img/profile/mail.svg">
                    {{ user.email || '尚未設定' }}
                </div>
                <div class="button">
                    <span @click="setMail">變更</span>
                </div>
            </div>
            <div class="item">
                <div class="title">
                    <img src="@/assets/img/profile/phone.png">
                    {{ user.phone }}
                </div>
                <div class="button">
                    <span @click="changePhone">變更</span>
                </div>
            </div>
            <div class="item">
                <div class="title">
                    <img src="@/assets/img/profile/location.svg">
                    <div class="address">
                        <span>常用地址</span>
                        <br/>
                        {{ fullAddress }}
                    </div>
                </div>
                <div class="button">
                    <span @click="goToAddress">變更</span>
                </div>
            </div>
        </div>
        <set-mail-modal ref="setMailModal"/>
        <change-phone-modal ref="changePhoneModal"/>
    </div>
</template>

<script>
    import Header from './components/Header';
    import { mapGetters, mapActions } from 'vuex';
    import SetMailModal from './components/modal/SetMailModal';
    import ChangePhoneModal from './components/modal/ChangePhoneModal';

    export default {
        name: 'Profile',
        components: {
            'p-header': Header,
            'set-mail-modal': SetMailModal,
            'change-phone-modal': ChangePhoneModal,
        },
        computed: {
            fullAddress() {
                if (! this.address) {
                    return '';
                }

                return this.address.city + this.address.district + this.address.road;
            },
            ...mapGetters(['user', 'address'])
        },
        methods: {
            setMail() {
                this.$refs.setMailModal.show(this.user.email);
            },
            changePhone() {
                this.$refs.changePhoneModal.show();
            },
            goToAddress() {
                this.$router.push({
                    name: 'addresses',
                });
            },
            ...mapActions(['getAddresses'])
        },
        created() {
            if (! this.address) {
                this.getAddresses();
            }
        },
        filters: {
            gender(gender) {
                if (gender === 'female') {
                    return '女性';
                }

                if (gender === 'male') {
                    return '男性';
                }

                return '未設定'
            }
        }
    };
</script>

<style lang="scss" scoped>
    .info {
        display: flex;
        justify-content: space-between;
        margin: 30px 25px;
        padding: 15px;
        color: #000000;
        border-bottom: solid 1px #D8D8D8;

        .name {
            font-size: 24px;
            font-weight: 500;
            line-height: 33px;
        }

        .gender {
            font-size: 14px;
            line-height: 20px;
            display: flex;
            align-items: flex-end;
        }
    }

    .menu {
        margin: 0 25px;

        .item {
            display: flex;
            justify-content: space-between;
            margin: 30px 15px;
            color: #000000;
            font-size: 14px;
            line-height: 20px;

            img {
                height: 30px;
                width: 30px;
                margin-right: 5px;
            }

            .title {
                display: flex;
                align-items: center;

                .address {
                    text-align: left;

                    span {
                        font-weight: 500;
                    }
                }
            }

            .button {
                display: flex;
                align-items: center;
                color: #339933;
                font-size: 12px;
                line-height: 17px;
            }
        }
    }
</style>
